import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" {...props}>
      <title>{"Close"}</title>
      <g fill="#FFF" fillRule="evenodd">
        <path d="M.333 22.046L21.546.833l2.121 2.121L2.454 24.167z" />
        <path d="M23.667 22.046L2.454.833.333 2.954l21.213 21.213z" />
      </g>
    </svg>
  )
}

export const CloseIcon = React.memo(SvgComponent)

CloseIcon.displayName = "CloseIcon"
